export default "__VITE_ASSET__CjyxOCam__"